import { FunctionComponent } from 'react';

import {
  DesktopHeader as KandaDesktopHeader,
  type DesktopHeaderProps as KandaDesktopHeaderProps,
} from '@kanda-libs/ks-design-library';

import { DESKTOP_COMPANY_ITEMS } from 'components/shared/DesktopHeader/constants';
import useLogout from 'hooks/useLogout';

import ReloadButton from './ReloadButton';

import { LinkMenuButton } from '../Link';
import { getVisitedMenuItems } from '../PresetFilter';

export type DesktopHeaderProps = KandaDesktopHeaderProps;

const DesktopHeader: FunctionComponent<DesktopHeaderProps> = function () {
  const logout = useLogout(false);
  const menuItems = getVisitedMenuItems();

  return (
    <div className="z-50 flex flex-1 w-full">
      <KandaDesktopHeader
        companyName="My Kanda"
        companyProfilePicture=""
        companyItems={DESKTOP_COMPANY_ITEMS}
        showAvatar={false}
        extraOptions={
          <>
            {menuItems.map((item) => (
              <LinkMenuButton key={item.to} path={item.to} text={item.name} />
            ))}
            <ReloadButton />
          </>
        }
        logout={logout}
      />
    </div>
  );
};

export default DesktopHeader;
